module.exports = __webpack_public_path__ + "static/img/4.a8976d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/zh/4.png
// module id = p+Dk
// module chunks = 0